<template>
  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-sim display-4 text-primary" style="transform: scaleX(1.2);"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            LINEAS TELEFONICAS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE LINEAS TELEFONICAS
          </p>
        </div>
      </div>
    </div>

    <div class="border border-1 rounded-3 p-3 mb-2">
      <div class="small-Bar-container">
        <Doughnut v-if="chartData" :data="chartData" :options="chartOptions" />
      </div>
    </div>

    <div class="row align-items-center mb-1 mx-0">
      <!-- Botones -->

      <div class="border border-1 rounded-3 p-3 mb-2">
        <div class="col-12 col-md-6 d-flex flex-wrap gap-2 mb-4 mb-md-0">
          <button class="btn btn-warning boton-estiloCuadrado" @click="abrirModal('agregar')">
            <i class="bi bi-plus"></i>
          </button>

          <button class="btn btn-danger boton-estiloCuadrado" :disabled="selectedRows.length === 0"
            @click="eliminarSeleccionados">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>

      <!-- Buscador -->
      <div class="border border-1 rounded-3 p-3 mb-2">
        <div class="row mb-3 justify-content-end mt-3">
          <div class="d-flex justify-content-end mt-2">
            <span for="" class="input-group-text mt-2 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
            <input class="form-control form-control-lg w-25 mt-2 me-2 buscar-estiloCuadrado" type="text"
              aria-label=".form-control-lg example" placeholder="NUMERO DE LA LINEA" v-model="busqueda"
              @keydown.space="busqueda.length === 0 && $event.preventDefault()" @input="filtro()" />
          </div>
        </div>


        <!-- Tabla -->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th>ID </th>

                <th @click="sortBy('desLinEstado')" class="cursor-pointer">
                  ESTADO
                  <i v-if="sortKey === 'desLinEstado'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- PROYECTO -->
                <th @click="sortBy('nomEmpLinea')" class="cursor-pointer">
                  PROYECTO
                  <i v-if="sortKey === 'nomEmpLinea'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- FEC. INICIO CONTRATO -->
                <th @click="sortBy('linFecIniContrato')" class="cursor-pointer">
                  FEC. INICIO CONTRATO
                  <i v-if="sortKey === 'linFecIniContrato'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- FEC. FIN CONTRATO -->
                <th @click="sortBy('linFecFinContrato')" class="cursor-pointer">
                  FEC. FIN CONTRATO
                  <i v-if="sortKey === 'linFecFinContrato'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- NÚMERO -->
                <th @click="sortBy('linNumero')" class="cursor-pointer">
                  NUMERO
                  <i v-if="sortKey === 'linNumero'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- PLAN ACTUAL -->
                <th @click="sortBy('linPlanActual')" class="cursor-pointer">
                  PLAN ACTUAL
                  <i v-if="sortKey === 'linPlanActual'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- MONTO A PAGAR -->
                <th @click="sortBy('linPlanCalculado')" class="cursor-pointer">
                  MONTO A PAGAR
                  <i v-if="sortKey === 'linPlanCalculado'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>

                <!-- MONTO CLIENTE -->
                <th @click="sortBy('linDesMonto')" class="cursor-pointer">
                  MONTO CLIENTE
                  <i v-if="sortKey === 'linDesMonto'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="10" class="text-center align-middle" style="height: 200px;">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <div class="spinner-border text-info" role="status" style="width: 3rem; height: 3rem;"></div>
                    <div class="mt-3 text-secondary fw-semibold">Filtrando información...</div>
                  </div>
                </td>
              </tr>

              <!-- Filas de datos solo cuando no está cargando -->
              <tr v-else v-for="linea in filasMostradas" :key="linea.idLinea"
                class="text-center align-middle reducirTamaño text-nowrap"
                :class="{ 'table-danger': linea.desLinEstado === 'SUSPENDIDO' }">

                <!-- BOTÓN -->
                <td>
                  <button class="btn btn-outline-success btn-sm boton-estiloCuadrado"
                    @click="abrirModal('editar', linea)" title="Editar línea">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>

                <!-- ID -->
                <td><strong>{{ linea.idLinea }}</strong></td>

                <!-- ESTADO -->
                <td>
                  <span :class="{
                    'text-success fw-bold': linea.desLinEstado === 'ACTIVO',
                    'text-danger fw-bold': linea.desLinEstado === 'SUSPENDIDO',
                    'text-primary fw-bold': linea.desLinEstado === 'ANULADO'
                  }">
                    <i class="bi" :class="{
                      'bi-check-circle-fill text-success': linea.desLinEstado === 'ACTIVO',
                      'bi-tools text-dark': linea.desLinEstado === 'SUSPENDIDO',
                      'bi-x-circle-fill text-primary': linea.desLinEstado === 'ANULADO'
                    }"></i>
                    {{ linea.desLinEstado }}
                  </span>
                </td>

                <!-- PROYECTO -->
                <td class="text-start">
                  <strong>{{ linea.nomEmpLinea }}</strong><br>
                  <small class="text-muted">{{ linea.desCentroCosto }}</small><br>
                  <small class="text-muted">{{ linea.desSubCentro }}</small><br>
                  <small class="text-muted">{{ linea.subsubCentroCosto }}</small>
                </td>

                <!-- FEC. INICIO -->
                <td>
                  <i class="bi bi-calendar-check text-success"></i>
                  {{ linea.linFecIniContrato }}
                </td>

                <!-- FEC. FIN -->
                <td>
                  <i class="bi bi-calendar-x text-danger"></i>
                  {{ linea.linFecFinContrato }}
                </td>

                <!-- NÚMERO -->
                <td class="text-start">
                  <strong>{{ linea.linNumero }}</strong><br>
                  <small class="text-muted">SIM: {{ linea.linSim }}</small><br>
                  <small class="text-muted">{{ linea.nombreDispositivo }}</small>
                </td>

                <!-- PLAN ACTUAL -->
                <td class="text-start">
                  <strong>{{ linea.linPlanActual }}</strong><br>
                  <small class="text-muted">CUENTA: {{ linea.linCuenta }}</small><br>
                  <span class="badge bg-info text-dark mt-1">DIA EMSION: {{ linea.linDiaEmision }}</span><br>
                  <span class="badge bg-secondary text-white mt-1">DESC. MESES: {{ linea.linDesPeriodo }}</span>
                </td>

                <!-- MONTO A PAGAR -->
                <td class="fw-bold text-success">
                  {{ 'S/. ' + linea.linPlanCalculado.toFixed(2) }}
                </td>

                <!-- MONTO CLIENTE -->
                <td class="fw-bold text-primary">
                  {{ 'S/. ' + linea.linMtoCliente.toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Paginación -->
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pagination-info">Página {{ currentPage }} de {{ totalPages }}</span>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>

    <div v-if="mostrarModal" class="modal-backdrop show" @click="cerrarModal"
      style="z-index: 1050; position: fixed; inset: 0; background-color: rgba(0, 0, 0, 0.5);"></div>

    <div v-if="mostrarModal" class="modal fade show d-block" tabindex="-1" role="dialog" style="z-index: 1055;">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable modal-ancho-personalizado"
        role="document" @click.stop>
        <div class="modal-content">
          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title text-center w-100 fw-bold text-uppercase">
              {{ modalModo === "agregar" ? "ASIGNAR NUEVA LÍNEA" : "MODIFICAR LÍNEA TELEFÓNICA" }}
            </h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>

          <!-- BODY -->
          <div class="modal-body">
            <form @submit.prevent="guardarModal">

              <!-- FILA 1 -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-building text-primary fs-5"></i> EMPRESA
                  </label>
                  <select required @change="EscogerEmpresa($event)" class="form-control text-secondary">
                    <option selected disabled>
                      {{ editarLinea.nomEmpLinea || '-- SELECCIONAR EMPRESA --' }}
                    </option>
                    <option v-for="empresa in DniEmpre" :key="empresa.id" :value="empresa.id">
                      {{ empresa.empRazSocial }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-geo-alt text-success fs-5"></i> CENTRO DE COSTO
                  </label>
                  <select required @change="EscogerCentroCos($event)" class="form-control text-secondary">
                    <option selected disabled>
                      {{ editarLinea.desCentroCosto || '-- SELECCIONAR CENTRO --' }}
                    </option>
                    <option v-for="CenCosto in CentroCosto" :key="CenCosto.id" :value="CenCosto.cenCodigo">
                      {{ CenCosto.cenNombre }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-diagram-3 text-warning fs-5"></i> SUBCENTRO DE COSTO
                  </label>
                  <select required @change="EscogerSubCen($event)" class="form-control text-secondary">
                    <option selected disabled>
                      {{ editarLinea.desSubCentro || '-- SELECCIONAR SUBCENTRO --' }}
                    </option>
                    <option v-for="SubCenCosto in SubCentroCosto" :key="SubCenCosto.id" :value="SubCenCosto.id">
                      {{ SubCenCosto.cenNombre }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- FILA 2 -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-diagram-2 text-info fs-5"></i> SUB-SUB CENTRO DE COSTO
                  </label>
                  <select required @change="EscogerSubSubCen($event)" class="form-control text-secondary">
                    <option selected disabled>
                      {{ editarLinea.subsubCentroCosto || '-- SELECCIONAR SUBSUBCENTRO --' }}
                    </option>
                    <option v-for="SubSubCenCosto in SubSubCentroCosto" :key="SubSubCenCosto.id"
                      :value="SubSubCenCosto.id">
                      {{ SubSubCenCosto.cenNombre }}
                    </option>
                  </select>
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-phone text-success fs-5"></i> N° CELULAR
                  </label>
                  <input v-model="linNumero" required type="text" class="form-control" placeholder="987654321"
                    @input="linNumero = linNumero.replace(/\s+/g, ''); validarNumero()" />
                  <label v-if="numeroValido" class="form-text text-danger">Número ya existente</label>
                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-sim text-danger fs-5"></i> SIM
                  </label>
                  <input v-model="linSim" required type="text" class="form-control" placeholder="0.0000000000"
                    @input="linSim = linSim.replace(/^\s+/, '')"
                    @keydown.space="linSim.length === 0 && $event.preventDefault()" />

                </div>

                <div class="col-md-3">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-bar-chart-line text-primary fs-5"></i> PLAN
                  </label>
                  <input v-model="linPlanActual" required type="text" class="form-control" placeholder="PLAN 0.00000000"
                    @input="linPlanActual = linPlanActual.replace(/^\s+/, '')" 
                    @keydown.space="linPlanActual.length === 0 && $event.preventDefault()" />
                </div>
              </div>

              <!-- FILA 3 -->
              <div class="row mb-3">
                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-calendar-check text-success fs-5"></i> FECHA INICIO
                  </label>
                  <input v-model="linFecIniContrato" required type="date" class="form-control" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-calendar-x text-danger fs-5"></i> FECHA FIN
                  </label>
                  <input v-model="linFecFinContrato" type="date" class="form-control" />
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-activity text-info fs-5"></i> ESTADO DE LÍNEA
                  </label>
                  <select required :disabled="modalModo == 'agregar'" @change="escogerEstado($event)"
                    class="form-control text-secondary">
                    <option selected disabled>{{ editarLinea.desLinEstado = "ACTIVO" }}</option>
                    <option v-for="estado in linEstadoLi" :key="estado.id" :value="estado.parCorrelativo">
                      {{ estado.parDescripcion }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-wallet2 text-warning fs-5"></i> CUENTA (TELEFONICA / ENTEL / CLARO)
                  </label>
                  <input v-model="linCuenta" required type="text" class="form-control"
                    placeholder="EJEMPLO: 10551815..." @input="linCuenta = linCuenta.replace(/^\s+/, '')" 
                     @keydown.space="linCuenta.length === 0 && $event.preventDefault()"/>
                </div>

                <div class="col-md-2">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-graph-up-arrow text-danger fs-5"></i> PLAN CALCULADO
                  </label>
                  <input v-model="linPlanContratado" required type="number" step="0.01" class="form-control"
                    placeholder="0.00" />
                </div>
              </div>

              <!-- FILA 4 -->
              <div class="row mb-3">
                <div class="col-md-1">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-calendar2-day text-secondary fs-5"></i> D. EMISIÓN
                  </label>
                  <input v-model="linDiaEmision" required type="number" class="form-control" placeholder="0.00" />
                </div>

                <div class="col-md-1">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-percent text-success fs-5"></i> DESCUENTO
                  </label>
                  <input v-model="linDesMonto" required type="number" step="0.01" class="form-control"
                    placeholder="0.00" />
                </div>

                <div class="col-md-1">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-person-lines-fill text-primary fs-5"></i> MTO. CLIENTE
                  </label>
                  <input v-model="linMtoCliente" required type="number" step="0.01" class="form-control"
                    placeholder="0.00" />
                </div>

                <div class="col-md-1">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-cash-stack text-success fs-5"></i> P. DSCTO
                  </label>
                  <input v-model="linDesPeriodo" required type="number" step="0.01" class="form-control"
                    placeholder="0.00" />
                </div>

                <div class="col-md-8">
                  <label class="form-label tamaño d-flex align-items-center gap-2">
                    <i class="bi bi-phone-fill text-dark fs-5"></i> ID DEL DISPOSITIVO
                  </label>
                  <select required @change="escogerId($event)" class="form-control text-secondary">
                    <option selected disabled>{{ editarLinea.nombreDispositivo || 'SELECCIONAR ID' }}</option>
                    <option v-for="Dispo in linIdDispositivos" :key="Dispo.id" :value="Dispo.idDispositivo">
                      {{ Dispo.nombreDispositivo }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- ACCIONES -->
              <div class="modal-actions mt-4 d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary px-4" @click="cerrarModal">Cancelar</button>
                <button :disabled="numeroValido" type="submit" class="btn btn-primary px-4">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";
ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default {
  name: "LineasTelefonicas",
  components: { Doughnut },
  data() {
    return {
      lineas: [],
      busqueda: "",
      paginaActual: 1,
      filasPorPagina: 10,
      selectedRows: [],
      mostrarModal: false,
      modalModo: "agregar",

      modalForm: {},
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      dniTrabajador: "",
      idEmpresa: "",
      fechaDeAhora: null,
      linEstadoLi: [],
      linEstado: "002",
      Dispositivos: [],
      CodCenCosto: "",
      CodSubCenCosto: "",
      CodSubSubCentro: "",
      loading: false,

      linNumero: "",
      linSim: "",
      linFecIniContrato: "",
      linFecFinContrato: "",
      linPlanActual: "",
      linCuenta: "",
      linDiaEmision: "",
      linPlanContratado: 0,
      linDesMonto: 0,
      linMtoCliente: 0,
      linDesPeriodo: "",
      idUsuario: "",
      linCenCosto: [],
      linSubCentro: [],
      linSubSubCentro: [],


      idLinea: "",
      editarLinea: {},
      currentPage: 1,
      itemsPerPage: 15,
      linIdDispositivos: [],
      linIdDispositivo: 0,
      numeroValido: false,
      sortKey: '',
      sortOrder: 'asc',

    };
  },
  computed: {
    copiasOrdenadas() {
      if (!this.sortKey) return this.copiasFiltradas;

      return [...this.copiasFiltradas].sort((a, b) => {
        let A = a[this.sortKey];
        let B = b[this.sortKey];

        // 📅 Fechas
        if (
          this.sortKey === "linFecIniContrato" ||
          this.sortKey === "linFecFinContrato"
        ) {
          A = new Date(A);
          B = new Date(B);
        }

        // 🔢 Números
        if (
          this.sortKey === "linPlanCalculado" ||
          this.sortKey === "linDesMonto" ||
          this.sortKey === "linMtoCliente"
        ) {
          A = Number(A);
          B = Number(B);
        }

        // 🔤 Strings
        if (typeof A === "string") A = A.toLowerCase();
        if (typeof B === "string") B = B.toLowerCase();

        if (A < B) return this.sortOrder === "asc" ? -1 : 1;
        if (A > B) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },
    filasMostradas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.copiasOrdenadas.slice(start, start + this.itemsPerPage);
    },


    chartData() {
      if (!this.lineas.length) return null;
      return {
        labels: ["PEOPLE", "TALSI", "SOLIMANO"],
        datasets: [
          {
            label: "Cantidad",
            data: [30, 20, 10],
            backgroundColor: [
              "rgba(75, 192, 192, 0.6)",
              "rgba(255, 99, 132, 0.6)",
              "rgba(255, 206, 86, 0.6)",
            ],
          },
        ],
      };
    },
    chartOptions() {
      return { responsive: true, plugins: { legend: { position: "bottom" } } };
    },
    copiasFiltradas() {
      if (!this.busqueda) return this.lineas;
      return this.lineas.filter((d) =>
        d.linNumero?.toLowerCase().includes(this.busqueda.toLowerCase())
      );
    },

    copiasPaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.copiasFiltradas.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      return Math.ceil(this.copiasOrdenadas.length / this.itemsPerPage);
    },

    ...mapGetters('users', ['DniEmpre']),
  },
  created() {
    // const tiempoTranscurrido = Date.now();
    // const hoy = new Date(tiempoTranscurrido);

    // this.fechaDeAhora = hoy.toISOString().slice(0, 10);


    this.dniTrabajador = localStorage.getItem("dniUsers");
    this.idUsuario = localStorage.getItem("userId");

    this.cambiarEstadoNavbar();

    this.obtenerLineas()
    this.axios.get(`ParametroData/Parametro/7716`).then(r => {
      this.linEstadoLi = r.data
    });
    this.obtenerDispoLineas()

  },
  methods: {
    sortBy(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = column;
        this.sortOrder = 'asc';
      }
      this.currentPage = 1; // 🔥 IMPORTANTE
    },

    obtenerDispoLineas() {
      this.axios.get(`Tecnologia/ObtenerDispositivosLineas`).then(r => {
        this.linIdDispositivos = r.data;
      });
    },

    abrirModal(modo, informacion) {
      this.modalModo = modo;

      if (modo === "editar") {
        this.editarLinea = informacion
        //this.editarRotac.desLinEstado="001"
        this.idLinea = informacion.idLinea;
        this.linPlanActual = informacion.linPlanActual;
        this.linNumero = informacion.linNumero;
        this.linSim = informacion.linSim;
        this.linIdDispositivo = informacion.linIdDispositivo;
        this.linCuenta = informacion.linCuenta;
        this.linDiaEmision = informacion.linDiaEmision;
        this.linPlanContratado = informacion.linPlanContratado.toFixed(2);
        this.linDesMonto = informacion.linDesMonto.toFixed(2);
        this.linMtoCliente = informacion.linMtoCliente?.toFixed(2);

        this.linDesPeriodo = informacion.linDesPeriodo;

        this.idEmpresa = informacion.empLinea;
        this.CodCenCosto = informacion.codCentroCosto;
        this.CodSubCenCosto = informacion.codSubCentro;
        this.CodSubSubCentro = informacion.codSubSubCentro;
        this.linEstado = informacion.linEstado;
        // this.linIdDispositivo = informacion.linIdDispositivo;
        console.log(this.editarLinea)

        this.linFecIniContrato = this.convertirFechaParaInput(informacion.linFecIniContrato);

        this.linFecFinContrato = this.convertirFechaParaInput(informacion.linFecFinContrato);

      } else {
        this.resetFormulario();
      }

      this.mostrarModal = true;
    },
    convertirFechaParaInput(fecha) {
      if (!fecha) return '';
      const partes = fecha.split('/');
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    },
    resetFormulario() {
      this.editarLinea = {};

      this.idLinea = "";
      this.linPlanActual = "";
      this.linNumero = "";
      this.linSim = "";
      this.linIdDispositivo = 0;
      this.linCuenta = "";
      this.linDiaEmision = "";
      this.linPlanContratado = "";
      this.linDesMonto = "";
      this.linMtoCliente = "";
      this.linDesPeriodo = "";
      this.linFecIniContrato = "";
      this.linFecFinContrato = "";
      this.numeroValido = false
    },

    cerrarModal() {
      this.mostrarModal = false;
      this.numeroValido = false
    },
    validarNumero() {
      console.log(this.linNumero)
      console.log(this.lineas)
      const dispositivo = this.lineas.find(dispositivo => dispositivo.linNumero == this.linNumero);
      this.numeroValido = dispositivo ? true : false;
      console.log(this.numeroValido)

    },
    escogerEstado(event) {
      this.linEstado = event.target.value;
    },
    escogerId(event) {
      this.linIdDispositivo = event.target.value;
    },
    cambiarEstadoNavbar() {
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    async obtenerLineas() {
      try {
        this.axios.get(`Tecnologia/listadoLineaTelefonica`).then((r) => {
          this.lineas = r.data;
        });
      } catch (error) {
        console.error(" Error al obtener líneas:", error);
      }
    },
    async guardarModal() {
      const Guardar = {
        linEmpresa: this.idEmpresa,
        linCenCosto: this.CodCenCosto,
        linSubCentro: this.CodSubCenCosto,
        linSubSubCentro: this.CodSubSubCentro,
        linNumero: this.linNumero,
        linSimCard: this.linSim,
        linFecIniContrato: `${this.linFecIniContrato}T00:00:00`,
        linFecFinContrato: `${this.linFecFinContrato}T00:00:00`,
        linPlanActual: this.linPlanActual,
        linEstado: this.linEstado,
        linIdDispositivo: this.linIdDispositivo,
        linCuenta: this.linCuenta,
        linDiaEmision: this.linDiaEmision,
        linPlanContratado: `${this.linPlanContratado}`,
        linDesMonto: `${this.linDesMonto}`,
        linMtoCliente: `${this.linMtoCliente}`,
        linDesPeriodo: `${this.linDesPeriodo}`,
        idUsuario: this.idUsuario,
      };

      if (this.modalModo === "agregar") {
        this.axios.post("Tecnologia/RegistrarLineaTelefonica", Guardar).then(r => {
          console.log(r.data)
          if (r.data.success) {
            Swal.fire({
              title: r.data.message == 'Insertado correctamente' ? "Operación exitosa" : "Error al registrar",
              text: `${r.data.message}`,
              icon: r.data.message == 'Insertado correctamente' ? "success" : "error"
            });
            this.obtenerDispoLineas();
            this.obtenerLineas();
            this.cerrarModal();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error al registrar",
              text: "No se Registro",
            });
          }
        });
      } else {
        Guardar.idLinea = this.idLinea;
        this.axios.put("Tecnologia/ModificarLineaTelefonica", Guardar).then(r => {
          console.log(r.data)
          if (r.data.success) {
            Swal.fire({
              title: "Operación exitosa",
              text: "Línea editada correctamente.",
              icon: "success"
            });
            this.obtenerDispoLineas();
            this.obtenerLineas();
            this.cerrarModal();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error al registrar",
              text: "No se pudo Editar ",
            });
          }
        });
      }

    },

    EscogerEmpresa(event) {
      console.log(event.target.value);
      this.idEmpresa = event.target.value;
      this.linEmpresa = event.target.value;

      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniTrabajador}`
        )
        .then((r) => {
          console.log(r.data);
          this.CentroCosto = r.data;
        });
    },


    EscogerCentroCos(event) {
      console.log(event.target.value);
      this.CodCenCosto = event.target.value
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniTrabajador}&idEmpresa=${this.idEmpresa}`
        )
        .then((r) => {
          this.SubCentroCosto = r.data;
        });
    },
    EscogerSubCen(event) {
      const idSeleccionado = parseInt(event.target.value); // o solo event.target.value si es string
      const subCentro = this.SubCentroCosto.find(
        (item) => item.id === idSeleccionado
      );
      this.CodSubCenCosto = subCentro.cenSubCentro

      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresa}&dniUser=${this.dniTrabajador}&codCentro=${subCentro.cenCodigo}&codSubCentro=${subCentro.cenSubCentro}`
        )
        .then((r) => {
          this.SubSubCentroCosto = r.data;
          console.log(r.data);
        });
    },
    EscogerSubSubCen(event) {
      this.axios
        .get(`SubSubCentro/ObtenerSububCentro/${event.target.value}`)
        .then((r) => {
          console.log(r.data);
          this.CodSubSubCentro = r.data[0].cenSubSubCodigo
        });
    },

    eliminarSeleccionados() {
      this.lineas = this.lineas.filter((l) => !this.selectedRows.includes(l));
      this.selectedRows = [];
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);
    },
  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.small-Bar-container,
.line-chart-container,
.stacked-bar-container {
  width: 100%;
  max-width: 250px;
  /* tamaño mediano */
  min-height: 200px;
  /* altura mediana */
  background: white;
  border-radius: 8px;
  padding: 15px;
  margin: 20px auto;
  /* centra horizontalmente en la página */
  display: flex;
  justify-content: center;
  /* centra el gráfico horizontal */
  align-items: center;
  /* centra el gráfico vertical */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-xl-custom {
  max-width: 90%;
}

.modal-ancho-personalizado {
  max-width: 80vw;
  width: 100%;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
